import React from 'react';
import { Snackbar, Alert } from '@mui/material';

const CustomSnackbar = ({ 
  open, 
  onClose, 
  message, 
  severity = 'warning',
  autoHideDuration = 4000 
}) => {
  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    onClose();
  };

  const getSeverityColor = (severity) => {
    switch (severity) {
      case 'error':
        return '#ef4444';
      case 'warning':
        return '#f59e0b';
      case 'info':
        return '#3b82f6';
      case 'success':
        return '#00B26C';
      default:
        return '#f59e0b';
    }
  };

  return (
    <Snackbar
      open={open}
      autoHideDuration={autoHideDuration}
      onClose={handleClose}
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
    >
      <Alert 
        onClose={handleClose} 
        severity={severity}
        sx={{ 
          width: '100%',
          bgcolor: 'white',
          color: '#012F47',
          '& .MuiAlert-icon': {
            color: getSeverityColor(severity)
          }
        }}
      >
        {message}
      </Alert>
    </Snackbar>
  );
};

export default CustomSnackbar;
